import React from "react";
import { observer } from "mobx-react";
import { InterpreterCreateStore } from "../../store";
import { InterpreterCreateForm } from "./InterpreterCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type InterpreterCreateProps = {
  interpreterCreateStore: InterpreterCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const InterpreterCreate: React.FC<InterpreterCreateProps> = observer(
  ({ interpreterCreateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={interpreterCreateStore.isSaving} />
        <InterpreterCreateForm
          interpreterCreateStore={interpreterCreateStore}
          nameError={interpreterCreateStore.errors.name?.message}
          onNameChange={(value: string) => {
            interpreterCreateStore.setNameValue(value);
          }}
          name={interpreterCreateStore.entityValues.name}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={interpreterCreateStore.isProcessing}
          onSave={() => interpreterCreateStore.saveNewInterpreter()}
          onCancel={() => interpreterCreateStore.cancelNewInterpreter()}
        />
        <ErrorDialog
          open={interpreterCreateStore.errorDialogOpened}
          title={interpreterCreateStore.errorTitle}
          description={interpreterCreateStore.errorDescription}
          onClose={() => interpreterCreateStore.closeErrorDialog()}
        />
      </>
    );
  }
);
